/*
 * View for the content URLs list
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/upload/contentUploadModel",
  "modules/contentsSplit/content/contentUrls/template/contentUrlsTemplate.html",
  "modules/contentsSplit/content/contentUrls/template/contentUrlsItemTemplate.html",
], function (
  Marionette,
  $,
  Messenger,
  ContentUploadModel,
  ContentUrlsTemplate,
  ContentUrlsItemTemplate,
) {
  var ContentUrlsView = {};

  ContentUrlsView.contentUrlView = Marionette.ItemView.extend({
    initialize: function (options) {
      this.language = options.language;
      //define template programmtically to decide whether the URL should be filtered out (different language)
      if (this.language === this.model.get("languageId")) {
        this.template = ContentUrlsItemTemplate;
      } else this.template = ""; //effectively filters the url
    },
    tagName: "tr",
    modelEvents: {
      enter: "render",
      change: "render",
    },
    textboxes: {
      ".contentUrlColumn > span": {
        enableSelector: ".contentUrlColumn > span",
        modelAttribute: "url",
        placeholder: "content.urls.url",
        textArea: false,
      },
    },
    events: {
      "change #fileUpload": function (event) {
        var fileName = event.target.files[0].name;
        var fileSize = event.target.files[0].size;
        var uploadForm = event.target.form;

        //fetch the extension from the file uploaded
        //this also handles flat files or extension only files (such as .htaccess)
        var ext = fileName.substr((~-fileName.lastIndexOf(".") >>> 0) + 2).toLowerCase();

        //check against list of valid extensions
        //will also be pulled from DB instead of hard-coded
        var validFileExtensions = [
          "jpg",
          "jpeg",
          "bmp",
          "gif",
          "png",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "ppt",
          "pptx",
          "pdf",
          "accdb",
          "rtf",
        ];

        if (validFileExtensions.indexOf(ext) === -1) {
          Messenger.okDialog("content.dialog.invalid");
          console.log("Invalid file type");
        } else if (fileSize > ContentUploadModel.contentUpload.MAX_SIZE) {
          Messenger.okDialog("content.dialog.tooLarge");
          console.log("File size exceeds maximum allowed");
        } else {
          //upload the file to the upload server
          Messenger.reqres.request("upload:content", uploadForm, fileName, fileSize, this.model);
        }
      },
      "click #removeButton": function (event) {
        event.preventDefault();
        Messenger.yesNoDialog(
          "content.dialog.deleteUpload",
          {
            yes: function () {
              const uploadId = this.model.get("uploadId");
              Messenger.vent.trigger("track:interaction", {
                action: "Delete Content Upload",
                id: uploadId,
                idType: "Content Upload",
                object: "Content Upload",
              });
              Messenger.reqres.request("delete:content", uploadId, this.model);
            },
          },
          this,
        );
      },
    },
    triggers: {
      "click #previewButton": "click:preview",
      "click #missingButton": "click:missing",
      "click #modifiedButton": "click:modified",
      "click #ignoredButton": "click:ignored",
    },
  });

  ContentUrlsView.contentUrlsView = Marionette.CompositeView.extend({
    initialize: function (options) {
      this.language = options.language;
    },
    itemView: ContentUrlsView.contentUrlView,
    itemViewContainer: "tbody",
    itemViewOptions: function () {
      return {
        language: this.language,
      };
    },
    template: ContentUrlsTemplate,
  });

  return ContentUrlsView;
});
